import React from 'react';
import { Card } from 'primereact/card';
import { ModernButton } from '../../components/ui/ModernButton';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export const UnauthorizedPage: React.FC = () => {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/agent/login');
    } catch (error) {
      console.error('Error signing out:', error);
      // Fallback to direct navigation
      navigate('/agent/login');
    }
  };

  return (
    <div className="unauthorized-page">
      <div className="unauthorized-container">
        <Card className="unauthorized-card">
          <div className="unauthorized-content">
            <div className="unauthorized-icon">
              <i className="pi pi-lock" style={{ fontSize: '4rem', color: '#e74c3c' }}></i>
            </div>
            <h2>Access Denied</h2>
            <p>
              You don't have permission to access the agent portal. 
              This area is restricted to authorized mortgage agents only.
            </p>
            <p>
              If you believe this is an error, please contact your administrator.
            </p>
            <div className="unauthorized-actions">
              <ModernButton
                variant="outline"
                icon="pi pi-sign-out"
                onClick={handleSignOut}
              >
                Sign Out
              </ModernButton>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

// Add some basic styling
const styles = `
.unauthorized-page {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 2rem;
}

.unauthorized-card {
  max-width: 500px;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  border: none;
}

.unauthorized-content {
  text-align: center;
  padding: 2rem;
}

.unauthorized-icon {
  margin-bottom: 2rem;
}

.unauthorized-content h2 {
  color: #2c3e50;
  margin-bottom: 1rem;
  font-size: 1.8rem;
}

.unauthorized-content p {
  color: #7f8c8d;
  margin-bottom: 1rem;
  line-height: 1.6;
}

.unauthorized-actions {
  margin-top: 2rem;
}
`;

// Inject styles
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement('style');
  styleSheet.innerText = styles;
  document.head.appendChild(styleSheet);
} 